import { render, staticRenderFns } from "./the-edit-notify.vue?vue&type=template&id=669dd2c6&scoped=true&"
import script from "./the-edit-notify.vue?vue&type=script&lang=js&"
export * from "./the-edit-notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669dd2c6",
  null
  
)

export default component.exports